/* eslint-disable no-console */
/* eslint-disable no-param-reassign */
/* eslint-disable react/no-unused-state */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/sort-comp */
/* eslint-disable radix */
/* eslint-disable max-classes-per-file */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import LinearProgress from '@mui/material/LinearProgress';
import Paper from '@mui/material/Paper';
import ReactAudioPlayer from 'react-audio-player';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import MuiAlert from '@mui/material/Alert';
import Slider from '@mui/material/Slider';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import Cookies from 'universal-cookie';
import Chart from 'react-google-charts';
import Switch from '@mui/material/Switch';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import {
  TableCellHead,
  ifdef,
  toString,
  SnackAlert,
  getApiHost,
  getLocationParam,
  renderBoilerPlate,
  TooltipTableCell,
  updateLocationSearchParams,
  loadingBackdrop,
  buildRequestsUrl,
  loadEvents,
  fetchApiRequest,
} from './Common';
import { setLocationState, buildLocationParams } from './AnnotationEvents';
import { UserContext } from './UserContext';
import { useTheme } from './ThemeContext';

let eventComponent = null;
let annotationComponent = null;
let explanationComponent = null;

class Event extends Component {
  static contextType = UserContext;

  constructor(props) {
    super(props);
    this.state = {
      event: {},
      annotationRequests: undefined,
      loading: false,
      warning: null,
      deleteConfirmation: false,
    };
    setLocationState(this.state);
    this.audioUrl = getLocationParam('audio_url');
    this.audioIndex = getLocationParam('audio_index');
    if (this.audioIndex !== null) this.audioIndex = parseInt(this.audioIndex);

    this.cookies = new Cookies();

    // Only restore global offset from cache if no audio_index was provided in URL
    // This ensures that links from AnnotationEvents table work correctly
    if (this.audioIndex === null || this.audioIndex === undefined) {
      const cacheMetadata = this.cookies.get('saferAnnotationsCacheMetadata');
      if (cacheMetadata && cacheMetadata.globalOffset !== undefined) {
        this.audioIndex = cacheMetadata.globalOffset;
      }
    }

    this.navigateEvent = this.navigateEvent.bind(this);
    this.handleDeleteEvent = this.handleDeleteEvent.bind(this);
    this.handleFindSimilar = this.handleFindSimilar.bind(this);
    this.predictCurrentScores = this.predictCurrentScores.bind(this);
    this.showTimestamp = this.showTimestamp.bind(this);
    this.isNavigating = false;
    this.hasFreshPredictions = false;
    this.isGettingFreshPredictions = false;
    eventComponent = this;
  }

  componentDidMount() {
    if (this.audioUrl === null)
      this.setState({
        warning:
          'No audio selected! Please click link ' +
          'in the dashboard or the annotations page',
      });

    // Listen for URL parameter changes
    this.handleUrlParamsChanged = this.handleUrlParamsChanged.bind(this);
    window.addEventListener('urlParamsChanged', this.handleUrlParamsChanged);

    // fetch existing data from bigquery
    getApiHost(apiHost => {
      this.audioControlUrl = `${apiHost}/v1/audio?` +
        `audio_url=${encodeURIComponent(this.audioUrl)}&audio_format=mp3`;
      this.eventsUrl = `${apiHost}/v1/annotation_requests`;
      this.predictEventUrl = `${apiHost}/v1/predict_event?` +
        `audio_url=${encodeURIComponent(this.audioUrl)}&reuse_preds=true`;
      fetchApiRequest(this.predictEventUrl, fetch => fetch
        .then((res) => res.json())
        .then((data) => {
          // Ensure current_events is properly handled
          if (data.current_events === null || data.current_events === undefined) {
            data.current_events = undefined;
          }
          this.setState({ event: data, loading: false }, () => {
            annotationComponent.fillAnnotation();
          });
        })
        .catch((e) => {
          console.log(`Fetch event error: ${e}`);
          this.setState({ loading: false });
        })
      );
    });
  }

  componentWillUnmount() {
    // Clean up event listener
    window.removeEventListener('urlParamsChanged', this.handleUrlParamsChanged);
  }

  handleUrlParamsChanged(event) {
    // Set navigation flag immediately
    this.isNavigating = true;

    // Update state with new URL parameters
    setLocationState(this.state);
    // Force a re-render by creating a new state object
    this.setState({ ...this.state });

    // Update audio URL and index from URL parameters
    const newAudioUrl = getLocationParam('audio_url');
    const newAudioIndex = getLocationParam('audio_index');

    if (newAudioUrl && newAudioUrl !== this.audioUrl) {
      this.audioUrl = newAudioUrl;

      // Only restore global offset from cache if no audio_index was provided in URL
      // This ensures that links from AnnotationEvents table work correctly
      if (newAudioIndex === null || newAudioIndex === undefined) {
        const cacheMetadata = this.cookies.get('saferAnnotationsCacheMetadata');
        if (cacheMetadata && cacheMetadata.globalOffset !== undefined) {
          this.audioIndex = cacheMetadata.globalOffset;
        } else {
          this.audioIndex = 0;
        }
      } else {
        this.audioIndex = parseInt(newAudioIndex);
      }

      // Reload the event data with the new audio URL
      this.setState({ loading: true });
      getApiHost(apiHost => {
        this.audioControlUrl = `${apiHost}/v1/audio?` +
          `audio_url=${encodeURIComponent(this.audioUrl)}&audio_format=mp3`;
        this.eventsUrl = `${apiHost}/v1/annotation_requests`;
        this.predictEventUrl = `${apiHost}/v1/predict_event?` +
          `audio_url=${encodeURIComponent(this.audioUrl)}&reuse_preds=true`;
        fetchApiRequest(this.predictEventUrl, fetch => fetch
          .then((res) => res.json())
          .then((data) => {
            // Ensure current_events is properly handled
            if (data.current_events === null || data.current_events === undefined) {
              data.current_events = undefined;
            }
            this.setState({ event: data, loading: false }, () => {
              // If we're getting fresh predictions, don't overwrite the state
              if (this.isGettingFreshPredictions) {
                return;
              }
              annotationComponent.fillAnnotation();
              // Clear the flag after a delay
              setTimeout(() => {
                this.isNavigating = false;
                this.hasFreshPredictions = false;
              }, 1000);
            });
          })
          .catch((e) => {
            console.log(`Fetch event error: ${e}`);
            this.setState({ loading: false });
          })
        );
      });
    } else {
      // Clear the flag if no audio URL change
      setTimeout(() => {
        this.isNavigating = false;
        this.hasFreshPredictions = false;
      }, 1000);
    }
  }

  predictCurrentScores() {
    // If we already have current_events and we're navigating, don't overwrite them
    if (this.isNavigating && this.state.event.current_events && this.state.event.current_events.length > 0) {
      return;
    }
    this.isGettingFreshPredictions = true;
    getApiHost(apiHost => {
      const predictEventUrl = (`${apiHost}/v1/predict_event?` +
          `audio_url=${encodeURIComponent(this.audioUrl)}&reuse_preds=false`);
      fetchApiRequest(predictEventUrl, fetch => fetch
        .then(res => res.json())
        .then(data => {
            // Ensure current_events is properly handled
            if (data.current_events === null || data.current_events === undefined) {
              data.current_events = undefined;
            }
            this.setState(
              { event: data },
              () => {
                this.hasFreshPredictions = true;
                this.isGettingFreshPredictions = false;
                explanationComponent.loadExplanations();
              }
            );
          })
        .catch((e) => {
          console.log(`PredictCurrentScores - Fetch event error: ${e}`);
          this.isGettingFreshPredictions = false;
        })
      );
    });
  }

  handleNext = () => this.navigateEvent(1);

  handlePrev = () => this.navigateEvent(-1);

  navigateEvent(relativeIndex) {
    const offset = this.audioIndex + relativeIndex;
    if (offset < 0)
      this.setState({
        warning: 'Already on the first event, no more previous events',
      });
    else {
      this.setState({ loading: true });
      const params = buildLocationParams(this.state);
      params.set('offset', offset);
      params.set('limit', 10); // ask for ten to set the cookie cache
      const saferAnnotationsCache = this.cookies.get('saferAnnotationsCache');
      if (saferAnnotationsCache && offset < saferAnnotationsCache.length) {
        if (relativeIndex === 0) {
          saferAnnotationsCache.splice(offset, 1);
          this.cookies.set('saferAnnotationsCache', saferAnnotationsCache, {
            maxAge: 3600,
            sameSite: 'lax',
          });
        }

        // Update cache metadata with current global offset
        const cacheMetadata = {
          globalOffset: offset,
          timestamp: Date.now()
        };
        this.cookies.set('saferAnnotationsCacheMetadata', cacheMetadata, {
          maxAge: 3600,
          sameSite: 'lax',
        });

        // Use the offset directly as the local index since we're maintaining global offset
        updateLocationSearchParams({
          audio_index: offset,
          audio_url: saferAnnotationsCache[offset],
        });
      } else {
        buildRequestsUrl(this.state, params, this.context, url => {
          fetchApiRequest(url, fetch => fetch
            .then((res) => res.json())
            .then((data) => {
              if (data.requests[0] !== undefined) {
                const audioUrl = data.requests[0].url;
                const newCache = data.requests.map((c) => c.url);
                this.cookies.set('saferAnnotationsCache', newCache, {
                  maxAge: 3600,
                  sameSite: 'lax',
                });

                // Store the global offset in the cache metadata BEFORE updating URL
                const cacheMetadata = {
                  globalOffset: offset,
                  timestamp: Date.now()
                };
                this.cookies.set('saferAnnotationsCacheMetadata', cacheMetadata, {
                  maxAge: 3600,
                  sameSite: 'lax',
                });

                // Keep the global offset in the URL instead of setting audio_index to 0
                // This maintains the correct navigation state
                updateLocationSearchParams({
                  audio_url: audioUrl,
                  audio_index: offset,
                });
              } else {
                this.setState({
                  loading: false,
                  warning:
                    `Unable to navigate to index ${relativeIndex}. ` +
                    `API response: ${JSON.stringify(data)}`,
                });
              }
            })
            .catch((error) => {
              console.log(`Fetch event error: ${error}`);
              this.setState({
                loading: false,
                warning: `Fetch event error: ${error}`,
              });
            })
          );
        });
      }
    }
  }

  calcAudioLength() {
    if (this.state.event.audio_shape == null)
      return 'Empty audio, unknown number of seconds';
    // eslint-disable-next-line react/destructuring-assignment
    const shape0 = this.state.event.audio_shape.match(/\d+/)[0];
    const seconds = shape0 / 12000;
    const minutes = Math.floor(seconds / 60);
    let remSeconds = seconds - minutes * 60;
    remSeconds = Math.round(remSeconds * 1000) / 1000;
    if (minutes > 0) return `${minutes} minutes ${remSeconds} seconds`;
    return `${remSeconds} seconds`;
  }

  render() {
    return renderBoilerPlate(
      <>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          {/* Two-column layout for annotation and event papers */}
          <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
            <div>{this.annotationPaper()}</div>
            <div>{this.eventPaper()}</div>
            <div>{this.annotationRules()}</div>
          </div>
          <div>
            <ExplanationPaperWithTheme />
          </div>
        </div>
        {loadingBackdrop({ open: this.state.loading })}
      </>,
    );
  }

  handleDeleteEvent() {
    this.setState({ loading: true, deleteConfirmation: false });
    getApiHost(apiHost => {
      const url = `${apiHost}/v1/predict_event?audio_url=${encodeURIComponent(this.audioUrl)}`;
      const callback = fetch => fetch
        .then((res) => res.json())
        .then(() => this.navigateEvent(0))
        .catch((e) => console.log(`fetch delete error: ${e}`));
      fetchApiRequest(url, callback, { method: 'delete' });
    });
  }

  handleFindSimilar() {
    const params = new URLSearchParams(window.location.search);
    params.delete('audio_url');
    params.delete('audio_index');
    params.set('similar', encodeURIComponent(this.audioUrl));
    const similarPath = `/?${params.toString()}#/annotations`;
    window.location = similarPath;
  }

  eventPaper() {
    return (
      <Paper>
        <Typography variant="subtitle1">Event Metadata</Typography>
        {this.eventTable()}
        <SnackAlert parent={this} state="warning" severity="warning">
          WARNING: {this.state.warning}
        </SnackAlert>
      </Paper>
    );
  }

  // eslint-disable-next-line class-methods-use-this
  blankLink(url, text) {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}>
        {text}
      </a>
    );
  }

  renderDeleteButton() {
    return (
      <>
        <Button
          type="button"
          variant="contained"
          color="success"
          onClick={this.handleFindSimilar}
        >
          Similar
        </Button>

        <Button
          type="button"
          variant="contained"
          color="error"
          onClick={() => this.setState({ deleteConfirmation: true })}
          disabled={this.state.deleteConfirmation}
        >
          Delete
        </Button>

        <Dialog
          open={this.state.deleteConfirmation}
          onClose={() => this.setState({ deleteConfirmation: false })}
          aria-labelledby="delete-dialog"
        >
          <DialogTitle id="delete-dialog">Delete Event</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Do you really want to delete this event?
              <br />
              <br />
              <code style={{ fontSize: '90%' }}>{this.audioUrl}</code>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              autoFocus
              color="primary"
              onClick={() => this.setState({ deleteConfirmation: false })}
            >
              Cancel
            </Button>
            <Button color="secondary" onClick={this.handleDeleteEvent}>
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }

  showTimestamp(timestamp, label, isUtc) {
    if (!timestamp) return;
    const timezoneString = isUtc ? ' UTC' : '';
    return (
      <TableRow>
        <TableCellHead>{label}</TableCellHead>
        <TableCell>{timestamp.substring(0, 19)} {timezoneString}</TableCell>
      </TableRow>
    );
  }

  eventTable() {
    if (Object.keys(this.state.event).length === 0) return <LinearProgress />;
    if (this.state.event.detail !== undefined)
      return (
        <>
          <MuiAlert elevation={6} variant="filled" severity="error">
            ERROR: {this.state.event.detail}
          </MuiAlert>
          {this.renderDeleteButton()}
        </>
      );

    return (
      <TableContainer>
        <Table size="small">
          <TableBody>
            <TableRow>
              <TableCellHead>Length</TableCellHead>
              <TableCell>{this.calcAudioLength()}</TableCell>
            </TableRow>

            {this.showTimestamp(
              this.state.event.server_timestamp, 'Server Timestamp', true)}
            {this.showTimestamp(
              this.state.event.client_timestamp, 'Client Timestamp')}

            <TableRow>
              <TableCellHead>Device</TableCellHead>
              <TooltipTableCell>{this.state.event.device_id}</TooltipTableCell>
            </TableRow>

            <TableRow>
              <TableCellHead>Place</TableCellHead>
              <TableCell>
                IP:{' '}
                {this.blankLink(
                  `https://www.whois.com/whois/${this.state.event.host_ip}`,
                  this.state.event.host_ip,
                )}{' '}
                &nbsp; LOC:{' '}
                <Tooltip
                  title={`Original location: ${this.state.event.location}`}
                >
                  {this.blankLink(
                    `https://www.google.com/maps/place/${this.state.event.clean_location}`,
                    this.state.event.clean_location,
                  )}
                </Tooltip>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCellHead>Class Label</TableCellHead>
              <TooltipTableCell>{ifdef(this.state.event.class_label)}</TooltipTableCell>
            </TableRow>

            <Tooltip title="Last prediction scores before current scores">
              <TableRow>
                <TableCellHead>Last Scores</TableCellHead>
                <TableCell>
                  {ifdef(this.state.event.events, (events) =>
                    events.map((e, i) => (
                      <span key={i}>
                        {ifdef(this.state.event.scores[i], (e_) =>
                          e_.toPrecision(5),
                        )}{' '}
                        {e}
                        <br />
                      </span>
                    )),
                  )}
                </TableCell>
              </TableRow>
            </Tooltip>

            <Tooltip title="Current scores performed with this request">
              <TableRow>
                <TableCellHead>Current Scores</TableCellHead>
                <TableCell>
                  <Grid container>
                    <div>{
                      (typeof this.state.event.current_events === 'undefined'
                      && <LinearProgress style={{width: '8rem'}} />)
                      || (this.state.event.current_events.map((e, i) => (
                          <span key={i}>
                            {e[1].toPrecision(5)} {e[0]}
                            <br />
                          </span>
                        )))
                    }</div>
                  </Grid>
                </TableCell>
              </TableRow>
            </Tooltip>

            <Tooltip title="Scores from the time of the last annotation">
              <TableRow>
                <TableCellHead>Annotation Scores</TableCellHead>
                <TableCell>
                  {ifdef(this.state.annotationRequests, (events) =>
                    events.map((e, i) => (
                      <span key={i}>
                        {e[1].toPrecision(5)} {e[0]}
                        <br />
                      </span>
                    )),
                  )}
                </TableCell>
              </TableRow>
            </Tooltip>
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

  annotationPaper() {
    if (this.state.event.detail !== undefined)
      return (
        <MuiAlert elevation={6} variant="filled" severity="error">
          ERROR: {this.state.event.detail}
        </MuiAlert>
      );
    return (
      <Paper>
        <Typography variant="subtitle1">
          Annotate Event&nbsp; [{this.blankLink(this.audioControlUrl, 'MP3')}]
        </Typography>
        <ReactAudioPlayer autoPlay controls src={this.audioControlUrl} />
        <div style={{ marginTop: '0.5rem' }}>
          <Button
            type="button"
            variant="outlined"
            onClick={() => {
              const params = new URLSearchParams(window.location.search);
              params.set('audio_url', this.audioUrl);
              window.location = `/?${params.toString()}#/analysis`;
            }}
          >
            Open in Analysis
          </Button>
        </div>
        <AnnotationForm />
      </Paper>
    );
  }

  annotationRules() {
    return (
      <Paper>
        <Typography variant="subtitle1">Annotation Rules</Typography>
        <Typography
          variant="body1"
          style={{ maxWidth: '23rem', fontSize: '0.8rem' }}
        >
          Please try adhering to the following principles to make the
          annotations as consistent as possible and avoid confusing the model.
        </Typography>
        <ul style={{ maxWidth: '23rem', fontSize: '0.8rem' }}>
          <li>
            If <strong>Casual</strong>, then do not select any other event
          </li>
          <li>
            If <strong>Gunshot</strong>, then do not select{' '}
            <strong>Human activity</strong> unless there is some human activity
            except <strong>Gunshot</strong> occuring
          </li>
          <li>
            If <strong>Human speech</strong>, then only select{' '}
            <strong>Human activity</strong> if something else than speech occurs
          </li>
          <li>
            If <strong>Dog bark</strong> or similar animal sounds, then select
            <strong>Animal activity</strong>
          </li>
          <li>
            If <strong>Car sounds</strong> or similar vehicle sound, then select
           <strong>Vehicle activity</strong>
          </li>
          <li>
            If <strong>Ignore</strong> is selected, then that event will be
            excluded from the model training completely
          </li>
        </ul>
      </Paper>
    );
  }
}

class AnnotationForm extends React.Component {
  static contextType = UserContext;

  constructor(props) {
    super(props);
    this.state = {
      events: null,
      annotation: null,
      loading: false,
      submitted: false,
      resetted: false,
    };
    this.bq_annotation = null;
    this.audio_url = getLocationParam('audio_url');
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleTextChange = this.handleTextChange.bind(this);
    this.handleClassLabelChange = this.handleClassLabelChange.bind(this);
    this.fillEvents = this.fillEvents.bind(this);
    this.loadAnnotations = this.loadAnnotations.bind(this);
    this.fillAnnotation = this.fillAnnotation.bind(this);
    this.updateAnnotations = this.updateAnnotations.bind(this);
    annotationComponent = this;
  }

  componentDidMount() {
    loadEvents(this.fillEvents, this.audio_url);
  }

  componentDidUpdate(prevProps, prevState) {
    const newAudioUrl = getLocationParam('audio_url');
    if (newAudioUrl !== this.audio_url) {
      this.audio_url = newAudioUrl;
      loadEvents(this.fillEvents, this.audio_url);
    }
  }

  fillEvents(events) {
    const eventChecked = {};
    // eslint-disable-next-line no-restricted-syntax
    for (const e of events) eventChecked[e.name] = false;
    this.setState(
      { events, event_checked: eventChecked },
      () => {
        if (eventComponent.isNavigating) {
          // If navigating, delay the prediction call
          setTimeout(() => {
            this.loadAnnotations(eventComponent.predictCurrentScores);
          }, 200);
        } else {
          // Normal flow
          this.loadAnnotations(eventComponent.predictCurrentScores);
        }
      }
    );
  }

  loadAnnotations(callback) {
    // eslint-disable-next-line no-param-reassign
    if (callback === undefined) callback = () => {};
    const audio_url = this.audio_url;

    // fetch annotation data from bigquery
    getApiHost(apiHost => {
      const url = `${apiHost}/v1/annotation?url=${encodeURIComponent(audio_url)}`;
      fetchApiRequest(url, fetch => fetch
        .then((res) => res.json())
        .then((data) => {
          this.bq_annotation = data;
          this.fillAnnotation();
          callback();
        })
        .catch((e) => {
          console.log(`fetch event error: ${e}`);
        })
      );
    });
}

  fillAnnotation() {
    let annotation = this.bq_annotation;
    if (
      eventComponent.state.event.events === undefined ||
      annotation === null
    )
      return; // wait until event component has loaded

    // set annotation events in Event Data paper
    const annotationDetail = annotation.detail;
    if (annotationDetail === undefined) {
      eventComponent.setState({
        annotationRequests: Object.entries(annotation.events),
      });
    } else {
      // no annotatin in bigquery, try finding matching event class_label
      const matchingEvent = this.state.events.find(
        (e) => e.name === eventComponent.state.event.class_label,
      );
      annotation =
        matchingEvent !== undefined
          ? { class_label: [matchingEvent.name] }
          : null;
    }

    if (annotation === null) {
      // no valid class labels found, try with new predictions
      const matchingEvents = this.state.events.filter((e) =>
        eventComponent.state.event.events.find(p => p === e.name),
      );
      if (matchingEvents.length > 0)
        annotation = { class_label: matchingEvents.map((e) => e.name) };
      else annotation = null;
    }

    if (annotation === null) annotation = { class_label: [] };

    const eventChecked = { ...this.state.event_checked };
    for (const label in eventChecked) eventChecked[label] = false;
    for (const label of annotation.class_label) eventChecked[label] = true;
    annotation.url = this.audio_url;
    annotation.comment = toString(annotation.comment);
    if (annotationDetail && annotationDetail.toLowerCase().includes('error'))
      annotation.detail = annotationDetail;
    this.setState({
      event_checked: eventChecked,
      annotation,
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    // update annotation through the APi
    const annotation = { ...this.state.annotation };
    annotation.class_label = [];
    for (const [label, checked] of Object.entries(this.state.event_checked))
      if (checked) annotation.class_label.push(label);
    // Add current event scores to annotation
    annotation.events = eventComponent.state.event.events
      ? eventComponent.state.event.events.map((e, i) =>
        [e, eventComponent.state.event.scores[i]])
      : null;
    const body = JSON.stringify(annotation);
    const fetchInit = {
      credentials: 'include',
      method: 'POST',
      body,
      headers: { 'Content-Type': 'application/json' },
    };
    this.setState({ loading: true });
    getApiHost(apiHost => {
      const url = `${apiHost}/v1/annotation?url=${encodeURIComponent(this.audio_url)}`;
      const callback = (fetch) => fetch
        .then(res => {
          if (res.ok) {
            res
              .json()
              .then(this.updateAnnotations)
              .catch((e) => console.log(`fetch event error: ${JSON.stringify(e)}`));
          } else {
            res.text().then((txt) => {
              this.setState({
                annotation: {
                  detail: `Submit annotation ${res.status} error: ${txt}`,
                },
              });
            });
          }
        });
      fetchApiRequest(url, callback, fetchInit);
    });
  }

  updateAnnotations() {
    this.setState({ loading: false, submitted: true });
    if (eventComponent.audio_index !== null) {
      // Check URL parameters directly instead of relying on state properties
      const annotated = getLocationParam('annotated') === 'true';
      const similar = getLocationParam('similar');
      if (annotated || similar) {
        eventComponent.navigateEvent(1);
      } else {
        eventComponent.navigateEvent(0);
      }
    } else {
      this.loadAnnotations();
    }
  }

  handleReset() {
    this.setState({ loading: true });
    this.loadAnnotations(() =>
      this.setState({ loading: false, resetted: true }),
    );
  }

  handleTextChange = (event) => {
    // react does not support nested states, but works with the spread operator
    // https://stackoverflow.com/questions/43040721/how-to-update-nested-state-properties-in-react
    const annotation = { ...this.state.annotation };
    annotation[event.target.name] = event.target.value;
    this.setState({ annotation });
  };

  handleClassLabelChange = (event) => {
    const eventChecked = { ...this.state.event_checked };
    if (event.target.name === 'Casual' && event.target.checked) {
      // if checking Casual, turn off all other events
      for (let key in eventChecked)
        eventChecked[key] = false;
    }
    else if (event.target.name !== 'Casual' && event.target.checked) {
      // if non Casual selected, uncheck Casual
      eventChecked['Casual'] = false;
    }
    eventChecked[event.target.name] = event.target.checked;
    this.setState({ event_checked: eventChecked });
  };

  buildCheckbox(label, key) {
    return (
      <FormControlLabel
        label={label}
        key={key}
        control={
          <Checkbox
            checked={this.state.event_checked[label]}
            name={label}
            onChange={this.handleClassLabelChange}
          />
        }
      />
    );
  }

  getLastAnnotationInfo() {
    if (this.state.annotation.timestamp !== undefined)
      return (
        <span>
          This annotation was last updated &nbsp;
          {this.state.annotation.timestamp.substring(0, 19)}
          <br />
          by &lt;{this.state.annotation.annotator_cred || 'unknown'}&gt;
          from IP address {this.state.annotation.annotator_ip}
        </span>
      );
    return <span>No previous annotation was found</span>;
  }

  render() {
    if (
      eventComponent.state.event.events === undefined ||
      this.state.annotation === null
    )
      return <LinearProgress />;

    const halfEventsSize = Math.ceil(this.state.events.length / 2);
    return (
      <form onSubmit={this.handleSubmit}>
        <FormGroup>
          <Typography variant="body2">
            {this.getLastAnnotationInfo()}
          </Typography>

          <div style={{ display: 'flex', gap: '1rem' }}>
            <div style={{ flex: 1 }}>
              <Grid container direction="column">
                {this.state.events
                  .slice(0, halfEventsSize)
                  .map((e, i) => this.buildCheckbox(e.name, i))}
              </Grid>
            </div>

            <div style={{ flex: 1 }}>
              <Grid container direction="column">
                {this.state.events
                  .slice(halfEventsSize)
                  .map((e, i) => this.buildCheckbox(e.name, i))}
              </Grid>
            </div>
          </div>

          <TextField
            variant="outlined"
            label="Optional comment"
            name="comment"
            margin="dense"
            multiline
            size="small"
            value={this.state.annotation.comment}
            onChange={this.handleTextChange}
            style={{ marginTop: '1rem', marginBottom: '1rem' }}
          />

          <Grid container justify="space-evenly">
            <Button
              type="button"
              variant="contained"
              color="primary"
              onClick={this.handleSubmit}
            >
              Annotate
            </Button>
            {eventComponent.audioIndex !== null && (
              <>
                <Button
                  type="button"
                  variant="contained"
                  onClick={eventComponent.handlePrev}
                >
                  Prev
                </Button>
                <Button
                  type="button"
                  variant="contained"
                  onClick={eventComponent.handleNext}
                >
                  Next
                </Button>
              </>
            )}
          </Grid>

          <Grid container justify="space-evenly" style={{ marginTop: '0.5rem' }}>
            <Button
              type="button"
              variant="contained"
              color="warning"
              onClick={this.handleReset}
            >
              Reset
            </Button>
            <Button
              type="button"
              variant="contained"
              color="success"
              onClick={eventComponent.handleFindSimilar}
            >
              Similar
            </Button>
            <Button
              type="button"
              variant="contained"
              color="error"
              onClick={() => eventComponent.setState({ deleteConfirmation: true })}
              disabled={eventComponent.state.deleteConfirmation}
            >
              Delete
            </Button>
          </Grid>

          <Dialog
            open={eventComponent.state.deleteConfirmation}
            onClose={() => eventComponent.setState({ deleteConfirmation: false })}
            aria-labelledby="delete-dialog"
          >
            <DialogTitle id="delete-dialog">Delete Event</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Do you really want to delete this event?
                <br />
                <br />
                <code style={{ fontSize: '90%' }}>{this.audio_url}</code>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                autoFocus
                color="primary"
                onClick={() => eventComponent.setState({ deleteConfirmation: false })}
              >
                Cancel
              </Button>
              <Button color="secondary" onClick={eventComponent.handleDeleteEvent}>
                Delete
              </Button>
            </DialogActions>
          </Dialog>

          <SnackAlert parent={this} state="submitted" severity="success">
            The annotations have been saved!
          </SnackAlert>

          <SnackAlert parent={this} state="resetted" severity="warning">
            The annotations have been resetted to last state!
          </SnackAlert>

          {this.state.annotation.detail !== undefined && (
            <MuiAlert elevation={6} variant="filled" severity="error">
              ERROR: <pre>{this.state.annotation.detail}</pre>
            </MuiAlert>
          )}
        </FormGroup>

        {loadingBackdrop({ open: this.state.loading })}
      </form>
    );
  }
}

// Wrapper component to provide theme context to class component
const ExplanationPaperWithTheme = (props) => {
  const { darkMode } = useTheme();
  return <ExplanationPaper {...props} darkMode={darkMode} />;
};

class ExplanationPaper extends React.Component {
  static contextType = UserContext;

  constructor(props) {
    super(props);
    this.top_event = '<Top event>';
    this.audio_url = getLocationParam('audio_url');
    this.cookies = new Cookies();
    this.state = {
      slices: null,
      enabled: this.getCookie('enabled', 'false') === 'true',
      alpha: this.getCookie('alpha', 0.4),
      sigma: this.getCookie('sigma', 8),
      steps: this.getCookie('steps', 20),
      event: this.top_event,
      events: [{ name: this.top_event }],
    };
    explanationComponent = this;
    this.loadExplanations = this.loadExplanations.bind(this);
    this.handleEnabledChange = this.handleEnabledChange.bind(this);
    this.handleEventChange = this.handleEventChange.bind(this);
    this.handleStepsChange = this.handleStepsChange.bind(this);
    this.handleAlphaChange = this.handleAlphaChange.bind(this);
    this.handleSigmaChange = this.handleSigmaChange.bind(this);
    this.handleUrlParamsChanged = this.handleUrlParamsChanged.bind(this);
  }

  getCookie(name, defaultValue) {
    const value = this.cookies.get(name);
    return value === undefined ? defaultValue : value;
  }

  componentDidMount() {
    // Listen for URL parameter changes
    window.addEventListener('urlParamsChanged', this.handleUrlParamsChanged);

    loadEvents(events => {
      events.unshift({ name: this.top_event });
      this.setState({ events });
    }, this.audio_url);
  }

  componentWillUnmount() {
    // Clean up event listener
    window.removeEventListener('urlParamsChanged', this.handleUrlParamsChanged);
  }

  handleUrlParamsChanged(event) {
    // Update audio URL from URL parameters
    const newAudioUrl = getLocationParam('audio_url');

    if (newAudioUrl && newAudioUrl !== this.audio_url) {
      this.audio_url = newAudioUrl;

      // Reload events for the new audio URL
      loadEvents(events => {
        events.unshift({ name: this.top_event });
        this.setState({ events, slices: null });
      }, this.audio_url);

      // Don't reload explanations during navigation - predictCurrentScores will handle it
      // if (this.state.enabled) {
      //   this.loadExplanations();
      // }
    }
  }

  loadExplanations() {
    if (!this.state.enabled) return;
    this.setState({ slices: null });
    getApiHost((apiHost) => {
      let explainPredictUrl =
        `${apiHost}/v1/explain_predict` +
        `?audio_url=${encodeURIComponent(this.audio_url)}` +
        `&steps=${this.state.steps}` +
        `&sigma=${this.state.sigma}` +
        `&dark_mode=${this.props.darkMode}`;
      if (this.state.event !== this.top_event)
        explainPredictUrl += `&event=${encodeURIComponent(this.state.event)}`;
      // explain_predict: start job then poll status until completed/failed
      const pollIntervalMs = 2500;
      const maxPolls = 120; // 5 min at 2.5s
      fetchApiRequest(explainPredictUrl, (fetch) => fetch
        .then((res) => res.json())
        .then((data) => {
          const jobId = data.job_id;
          if (!jobId) throw new Error('No job_id in explain_predict response');
          return new Promise((resolve, reject) => {
            let pollCount = 0;
            const statusUrl = `${apiHost}/v1/explain_predict/status/${jobId}`;
            const poll = () => {
              pollCount += 1;
              if (pollCount > maxPolls) {
                reject(new Error('Explain job timed out'));
                return;
              }
              fetchApiRequest(statusUrl, (statusFetch) => statusFetch
                .then((r) => r.json())
                .then((s) => {
                  if (s.status === 'completed') {
                    resolve(s.result);
                    return;
                  }
                  if (s.status === 'failed') {
                    reject(new Error(s.error || 'Explain job failed'));
                    return;
                  }
                  setTimeout(poll, pollIntervalMs);
                })
                .catch(reject));
            };
            poll();
          });
        })
        .then((result) =>
          this.setState({ event: result.event, slices: result.slices }),
        )
        .catch((e) => console.log(`fetch events error: ${e}`)),
      {});
    });
  }

  updateStateAndCookie(state, callback) {
    this.setState(state, callback);
    Object.entries(state).map((e) =>
      this.cookies.set(e[0], e[1], { sameSite: 'lax' }),
    );
  }

  handleEnabledChange = (_e, v) =>
    this.updateStateAndCookie({ enabled: v }, this.loadExplanations);

  handleEventChange = (_e, v) =>
    this.updateStateAndCookie({ event: v.props.value }, this.loadExplanations);

  handleStepsChange = (_e, v) => this.updateStateAndCookie({ steps: v });

  handleAlphaChange = (_e, v) => this.updateStateAndCookie({ alpha: v });

  handleSigmaChange = (_e, v) => this.updateStateAndCookie({ sigma: v });

  render() {
    let content = [];
    const controls = [
      <FormControlLabel
        key="control-1"
        labelPlacement="start"
        style={{ height: '1.8rem', marginLeft: 0 }}
        control={
          <Switch
            checked={this.state.enabled}
            onChange={this.handleEnabledChange}
            color="primary"
            name="enable"
            style={{ bottom: '1px' }}
          />
        }
        label="Enable"
      />,
    ];
    if (this.state.enabled) {
      if (this.state.slices === null)
        content = [<LinearProgress key="loading" />];
      else {
        controls.push([
          <span key="enabled">
            <FormControlLabel
              label="Steps &nbsp;"
              labelPlacement="start"
              style={{ marginRight: '1rem' }}
              control={
                <Slider
                  value={parseInt(this.state.steps)}
                  aria-valuetext="Steps"
                  valueLabelDisplay="auto"
                  style={{ minWidth: '7rem' }}
                  onChange={this.handleStepsChange}
                  onChangeCommitted={this.loadExplanations}
                  step={1}
                  min={1}
                  max={200}
                />
              }
            />
            <FormControlLabel
              label="Alpha &nbsp;"
              labelPlacement="start"
              style={{ marginRight: '1rem' }}
              control={
                <Slider
                  value={parseFloat(this.state.alpha)}
                  aria-valuetext="Alpha"
                  valueLabelDisplay="auto"
                  style={{ minWidth: '7rem' }}
                  onChange={this.handleAlphaChange}
                  step={0.01}
                  max={1.0}
                />
              }
            />
            <FormControlLabel
              label="Smoothing &nbsp;"
              labelPlacement="start"
              style={{ marginRight: '1rem' }}
              control={
                <Slider
                  value={parseFloat(this.state.sigma)}
                  aria-valuetext="Smoothing sigma"
                  valueLabelDisplay="auto"
                  style={{ minWidth: '7rem' }}
                  onChange={this.handleSigmaChange}
                  onChangeCommitted={this.loadExplanations}
                  step={0.1}
                  max={20.0}
                />
              }
            />
            <FormControl style={{ marginLeft: '2rem' }}>
              <Select
                id="event"
                value={this.state.event}
                style={{ paddingBottom: 0 }}
                onChange={this.handleEventChange}
              >
                {this.state.events.map((e, i) => (
                  <MenuItem key={i} value={e.name}>
                    {e.name}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>Event</FormHelperText>
            </FormControl>
          </span>,
        ]);
        for (const i in this.state.slices) {
          const specSrc = `data:image/png;base64,${this.state.slices[i].spectrograms}`;
          const gradSrc = `data:image/png;base64,${this.state.slices[i].gradients}`;
          content.push(
            <div key={`p-${i}`} style={{ position: 'relative' }}>
              <div style={{
                backgroundColor: this.props.darkMode ? '#000000' : '#ffffff',
                display: 'inline-block',
                padding: '10px',
                borderRadius: '4px',
                position: 'relative'
              }}>
                <img key={`spec-${i}`} alt="Spectrograms" src={specSrc} />
                <img
                  key={`grad-${i}`}
                  alt="Gradients"
                  src={gradSrc}
                  style={{
                    position: 'absolute',
                    top: '10px',
                    left: '10px',
                    opacity: this.state.alpha,
                  }}
                />
              </div>
              <Grid container style={{ marginLeft: '33px' }}>
                <Grid>
                  <Chart
                    width="430px"
                    height="200px"
                    chartType="AreaChart"
                    data={this.state.slices[i].histograms.inputs}
                    options={{
                      title: 'Histogram of inputs values',
                      legend: { position: 'bottom' },
                      backgroundColor: this.props.darkMode ? '#000000' : '#ffffff',
                      titleTextStyle: {
                        color: this.props.darkMode ? '#ffffff' : '#000000',
                      },
                      legend: {
                        position: 'bottom',
                        textStyle: {
                          color: this.props.darkMode ? '#ffffff' : '#000000',
                        },
                      },
                      hAxis: {
                        textStyle: {
                          color: this.props.darkMode ? '#ffffff' : '#000000',
                        },
                      },
                      vAxis: {
                        textStyle: {
                          color: this.props.darkMode ? '#ffffff' : '#000000',
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid>
                  <Chart
                    width="430px"
                    height="200px"
                    chartType="AreaChart"
                    data={this.state.slices[i].histograms.gradients}
                    options={{
                      title: 'Histogram of gradient values',
                      legend: { position: 'bottom' },
                      backgroundColor: this.props.darkMode ? '#000000' : '#ffffff',
                      titleTextStyle: {
                        color: this.props.darkMode ? '#ffffff' : '#000000',
                      },
                      legend: {
                        position: 'bottom',
                        textStyle: {
                          color: this.props.darkMode ? '#ffffff' : '#000000',
                        },
                      },
                      hAxis: {
                        textStyle: {
                          color: this.props.darkMode ? '#ffffff' : '#000000',
                        },
                      },
                      vAxis: {
                        textStyle: {
                          color: this.props.darkMode ? '#ffffff' : '#000000',
                        },
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </div>,
          );
        }
      }
    }

    return (
      <Paper>
        <Typography variant="subtitle1">Explanation</Typography>
        <Grid container key="form-grid" style={{ marginLeft: 0 }}>
          {controls}
        </Grid>
        {content}
      </Paper>
    );
  }
}

export default withRouter(Event);
